const FeaturedResources = () => {
    const feaatureResources = document.querySelectorAll('.featured_resources .resource_list__items_card');

    if (!feaatureResources) {
        return;
    }
    feaatureResources.forEach(function (card) {
        card.addEventListener('click', function (event) {
            const clickedElement = event.target;
            if (!clickedElement || !clickedElement.closest) {
                return;
            }

            // Respect native behavior for interactive elements inside the card.
            if (clickedElement.closest('a, button, input, select, textarea, label')) {
                return;
            }

            const cardLink = card.querySelector('.resource_single_link[href]');
            if (!cardLink) {
                return;
            }

            cardLink.click();
        });
    });
};

export default FeaturedResources;
